import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactLoading from 'react-loading';
import { OrganizationOrder } from "../../components/OrganizationOrder";
import { OrganizationOrderForm } from "../../gateways/cms/organization";
import { useGetOrganizationOrderQuery, useUpdateOrganizationOrderMutation } from "../../gateways/cms/organizationApi";
import MainLayout from "../../layouts/MainLayout";
import { styled } from "@mui/system";
import Stack from "@mui/material/Stack";
import ButtonMUI from "@mui/material/Button";

// style
const PageTitle = styled("section")`
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    padding: 24px 94px 34px 54px;

    h1,
    h2 {
        font-size: 24px;
        font-weight: normal;
        margin: 0;
        margin: 0 16px 0 0;
    }
    h2 small {
        margin: 0 0 0 16px;
        font-size: 60%;
    }

    /* & > div:first-child{
        display: flex;
    } */
    & > div:last-child {
        .MuiButton-root {
            width: 116px;
            margin-left: 16px;
        }
    }
`;
const PageMain = styled("section")`
    display: flex;
    flex-direction: column;
    margin: auto;
    padding: 0 20px 0 0;
    overflow: hidden;
`;
const Button = styled(ButtonMUI)`
    height: 32px;
    border-radius: 2px;
`;
const Loading = styled("section")`
    position: relative;
    left: 45%;
    top: 35%;
    b {
        font-size: 12px;
        color: #A9A9A9;
        font-weight: normal;
    }
`; 

export const OrganizationOrderPage = () => {
    const navigate = useNavigate();
    const [organizationOrderUpdate] = useUpdateOrganizationOrderMutation();
    const handleSave = async () => {
        organizationOrderUpdate(organizationOrders).then(() => navigate(`/organizations`));
    };
    const handleOrganizationOrder = (organizationDatas: OrganizationOrderForm[]) => {
        const orders = organizationDatas.map((organizationData) => organizationData.id);
        setOrganizationOrders(orders);
    }
    const [organizationOrders, setOrganizationOrders] = useState([] as number[]);
    const organizations = useGetOrganizationOrderQuery();

    if (organizations.isFetching) {
        return (
            <MainLayout title="テナント表示順管理">
                <Loading>
                    <ReactLoading type="bars" color="#ADD8E6" height={'-1%'} width={'8%'} />
                    <b>テナントデータ取得中</b>
                </Loading>
            </MainLayout>
        );
    };

    return (
        <MainLayout title="テナント表示順管理">
            <PageTitle>
                <h1>テナント表示順管理</h1>
                <Stack spacing={1} direction="row">
                    <Button variant="outlined" disableElevation href="/organizations">
                        {" "}キャンセル{" "}
                    </Button>
                    <Button variant="contained" disableElevation onClick={handleSave}>
                        {" "}保存{" "}
                    </Button>
                </Stack>
            </PageTitle>
            <PageMain>
                <OrganizationOrder
                    organizations={organizations.data || []}
                    organizationOrders={handleOrganizationOrder}
                />
            </PageMain>
        </MainLayout>
    );
};
